export * from "./animations";
export * from "./routes";

export function getRuntimeEnv(key) {
  if (typeof window !== "undefined" && window.__RUNTIME_ENV__ && window.__RUNTIME_ENV__[key] !== undefined) {
    return window.__RUNTIME_ENV__[key];
  }
  return process.env[key];
}

export const HeaderHeight = 60;
export const _TOKEN_ = "mnctk";
export const DefaultPaginable = {
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "50", "100"],
};
export const Error = (desc, duration = 5) => ({
  message: "เกิดข้อผิดพลาด",
  description: desc,
  duration,
});
export const Info = (desc, duration = 5) => ({
  message: "แจ้งให้ทราบ",
  description: desc,
  duration,
});

export const defaultDecimal = 2;

export const UnitDisplay = {
  UNIT: "unit",
  BAHT: "baht",
};

export const DisplayType = {
  BAHT: "baht",
  PERCENT: "percent",
};

export const SUCCESS_STATUS = "SUCCESS";

export const DisclaimerType = {
  DisclaimerPage: "DISC01",
  DisclaimerPage_ACCEPT_1: "DISC02",
  DisclaimerPage_ACCEPT_2: "DISC03",
  AcceptWarningRisk: "DISC04",
  HighRisk: "DISC05",
  FXRisk: "DISC06",
  ConfirmPersonalInfo: "DISC07",
  HNW: "DISC08",
  HNW_SPOUSE: "DISC09",
  HNW_INCOME_4M_OR_MORE: "DISC10",
  HNW_INVESTMENT_10_MILLION: "DISC11",
  PDPA: "DISC12",
  NoneHNW: "DISC13",
  FundFactsheet: "DISC16",
  // SM_ACCEPT_VULNERABLE: "DISC23", // Dynamic Code from BE // cancel DISC17
  // SM_ACCEPT_VULNERABLE_1: "DISC18",
  // SM_ACCEPT_VULNERABLE_2: "DISC19",
  PDPA_COMP: "DISC20",
  AFFIRM_UHNW_WITHOUT_EVIDENCE: "DISC21",
  RiskDocument: "DISC22",
  AmendHNW: "DISC27",
  Amend2ndHNW: "DISC28",
  RiskDocumentFor2ndMarket: "DISC29",
  FutureRisk: "DISC30",
  BondConnectPDPA: "DISC31",
  CustodianFeeAcknowledgement: "DISC32",
  OffshoreTermAndConditions: "DISC33",
  CertificateOfUseAndConditionsOfService: "DISC34",

  HNW_WEALTH: "HNWW000",
  HNW_WEALTH_CHOICE_1: "HNWW001",
  HNW_WEALTH_CHOICE_2: "HNWW002",
  HNW_WEALTH_CHOICE_3: "HNWW003",

  HNW_EXPERIENCE: "HNWE000",
  HNW_EXPERIENCE_CHOICE_1: "HNWE001",
  HNW_EXPERIENCE_CHOICE_2: "HNWE002",
  HNW_EXPERIENCE_CHOICE_2_SUB_1: "HNWE002.1",
  HNW_EXPERIENCE_CHOICE_3: "HNWE003",
  HNW_EXPERIENCE_CHOICE_3_SUB_1: "HNWE003.1",
  HNW_EXPERIENCE_CHOICE_4: "HNWE004",
  HNW_EXPERIENCE_CHOICE_5: "HNWE005",
  HNW_EXPERIENCE_CHOICE_6: "HNWE006",

  UHNW_WEALTH: "UHNWW000",
  UHNW_WEALTH_CHOICE_1: "UHNWW001",
  UHNW_WEALTH_CHOICE_2: "UHNWW002",
  UHNW_WEALTH_CHOICE_3: "UHNWW003",

  UHNW_EXPERIENCE: "UHNWE000",
  UHNW_EXPERIENCE_CHOICE_1: "UHNWE001",
  UHNW_EXPERIENCE_CHOICE_2: "UHNWE002",
  UHNW_EXPERIENCE_CHOICE_2_SUB_1: "UHNWE002.1",
  UHNW_EXPERIENCE_CHOICE_3: "UHNWE003",
  UHNW_EXPERIENCE_CHOICE_3_SUB_1: "UHNWE003.1",
  UHNW_EXPERIENCE_CHOICE_4: "UHNWE004",
  UHNW_EXPERIENCE_CHOICE_5: "UHNWE005",
  UHNW_EXPERIENCE_CHOICE_6: "UHNWE006",

  CRUCIAL_RISK_DOC: "DCN001",
};

export const DisclaimerTypeHelper = {
  ConfirmSelfDeclare: "HNW_CONFIRM_SELF_DECLARE",
};

export const RiskProfileErrors = {
  SystemNotReady: "SYSTEM_NOT_READY",
};

export const FATCA = {
  NO_DATA: "FATCA_NO_DATA",
};

export const SecondaryError = {
  NoSecuritiesFoundInPort: "SMK003",
};

export const AcceptType = {
  Factsheet: "ACT_FACTSHEET",
  FactsheetCustomMessage: "ACT_FACTSHEET_CUSTOM_MESSAGE",
  PWMRegister: "PWM_REGISTER",
  PwmRegisterInfo: "PWM_REGISTER_INFO",
  RiskDesc: "ACT_RISKDESC",
  SecondMarketInvestment: "SECOND_MARKET_INVESTMENT",
  UnitAvaliable: "ACT_UNIT_AVALIABLE",
  GoldOrderContract: "ACT_GOLD_ORDER_CONTRACT",
  OffshoreNonFaceCRS: "ACT_OFFSHORE_NON_FACE_CRS",
};

export const CentralModalType = {
  ValidateDepositAccount: "VALIDATE_DEPOSIT_ACCOUNT_MODAL",
  OffshoreInformPopups: "OFFSHORE_INFORM_POPUPS",
};

export const ErrorType = {
  FACTA_AML_CBS: "73004",
  AGE_OVER_60: "DCM001",
  ATTITUDE: "DCM002",
  EXPERIENCE: "DCM003",
  BALANCE_NOT_ENOUGH: "43957",
  INVALID_UNIT_PO: "43946",
  INVALID_UNIT_RO: "43958",

  INVALID_MAX_UNIT_PO: "NB0005",
  INVALID_MAX_UNIT_RO: "NB0002",
  INVALID_MAX_UNIT_MESSAGE: "NB0003",

  SETTLE_FULLY_PURCHASE: "43949",
  SETTLE_REMAIN_NOT_ENOUGH: "43950",
  CBS_FULLY_PURCHASE: "43969",
  CBS_REMAIN_NOT_ENOUGH: "43970",

  OTP_FAIL_LIMIT_EXCEED: "6915",
  CUT_OFF_TIME_REQUIRE_ACCEPT: "77005",
  REF_PRICING_NOT_MATCH: "SMK009",
  CHANNAL_STATUS_NOT_MATCH: "SMK012",

  TAX_ID_MISSING_1: "PAS001",
  TAX_ID_MISSING_2: "PAS002",

  SystemClose: "503",

  NONE_HNW_CONTACT_BRANCH: "IIHNW000",
};

export const SecurityType = {
  UNT: "UNT",
  DBT: "DBT",
  STO: "STO",
  COM: "COM",
  SB: "SB",
};

export const OfferType = {
  PO: "PO",
  RO: "RO",
  COM: "COM",
};

export const DistributionMethod = {
  FCFS: "F",
  Allotment: "A",
};

export const ReceiveMethod = {
  POSTAL: "01",
  BROKER: "02",
  TSD: "03",
  KTB: "04",
};

export const PaymentMethod = {
  payNow: {
    th: "หักบัญชีทันที",
    en: "Pay Now",
  },
  payLater: {
    th: "หักบัญชีภายหลัง",
    en: "Pay Later",
  },
  notPay: {
    th: "ไม่มีการชำระเงิน",
    en: "No Pay",
  },
};

export const Direction = {
  Default: 0,
  Previous: -1,
  Next: 1,
};

export const PWM_RESTORE = "pwmSavePoint";

export const KRUNGTHAI_BANK_CODE = "006";

export const Gender = {
  Male: "M",
  Female: "F",
};

export const GenderOption = {
  TH: [
    { label: "ชาย", value: Gender.Male },
    { label: "หญิง", value: Gender.Female },
  ],
  EN: [
    { label: "Male", value: Gender.Male },
    { label: "Female", value: Gender.Female },
  ],
};

export const TITLE_OTHER_TH = "อื่นๆ";
export const TITLE_OTHER_EN = "Other";

export const TitleOption = {
  TH: [
    { label: "นาย", value: "นาย", gender: Gender.Male },
    { label: "นาง", value: "นาง", gender: Gender.Female },
    { label: "น.ส.", value: "น.ส.", gender: Gender.Female },
    { label: TITLE_OTHER_TH, value: TITLE_OTHER_TH },
  ],
  EN: [
    { label: "MR.", value: "MR.", gender: Gender.Male },
    { label: "MS.", value: "MS.", gender: Gender.Female },
    { label: "MRS.", value: "MRS.", gender: Gender.Female },
    { label: TITLE_OTHER_EN, value: TITLE_OTHER_EN },
  ],
};

export const DELAY_RESEND_OTP = 60 * 1000;
export const RedType = {
  unit: 1,
  baht: 2,
  all: 3,
};
export const TabName = {
  HOLDING_TRANS: "holding_trans",
  RETROSPECTIVE_TRANS: "retrospective_trans",
  SECOND_BUY_SELL: "second_buy_sell",
  MY_SECONDARY: "my_secondary",
};
export const FundTransactionType = {
  Buy: 1,
  Sell: 2,
  Switch: 5,
};
export const FundTransactionStatus = {
  Success: "S",
  Pending: "P",
  Holding: "H",
  Cancel: "C",
  Fail: "F",
  Fail_LACK_MONEY: "I",
};

export const FundTransactionStatusFilter = {
  "bss.trans.status.all": "A",
  "bss.trans.status.success": "S",
  "bss.trans.status.cancel": "C",
  "bss.trans.status.failure": "F",
  "bss.trans.status.failure-lack-money": "I",
};

export const PrecisionConfig = {
  // key is unit display
  BuySellSwitch: {
    baht: 2,
    unit: 4,
    all: 4, // like a unit
  },
};

export const NavigatorButtomMenu = {
  PWM: "pwm",
  Retail_And_Ultrahigh: "retail_and_ultrahigh",
};

export const BondType = {
  GB: "GB",
  Bond: "Bond",
};

export const BankDirection = {
  BUY: "Buy",
  SELL: "Sell",
};

export const CouponType = {
  ZERO: "ZERO",
  FIXED: "FIXED",
};

export const PeriodBarType = [
  { name: "3 เดือน", value: "3m" },
  { name: "6 เดือน", value: "6m" },
  { name: "YTD", value: "y" },
  { name: "1 ปี", value: "1y" },
  { name: "3 ปี", value: "3y" },
  { name: "สูงสุด", value: "s" },
];

export const measureOptions = { polyfill: ResizeObserver };

export const NavigatorHeight = 80;

export const MncVars = {
  Header: "--header-height",
  Navbar: "--nav-height",
};

export const RejectProcess = "#canceled";

export const MuleAccountPopupError = {
  messageId: "global.mule-account.error.message",
  state: {
    titleMessageId: "global.mule-account.error.title",
    // hideIcon: true,
    // hideSubTitleMessage: true,
  },
};

export const BrokerCode = {
  CUSTODIAN: "425",
};

export const BrokerShortName = {
  KTX: "KTX",
};

export const CustodianRegisterStatus = {
  NORMAL: { code: "00", label: "ready to purchase" },
  WAITING: { code: "01", label: "waiting for approval" },
  EXPIRED: { code: "02", label: "register expire" },
  REGISTER: { code: "03", label: "register custodian account" },
  REGISTER_SUCCESS: { code: "04", label: "register with MNC success" },
};
